import "core-js/modules/es.object.to-string.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
export function didUpdateToBool(didUpdate, id) {
  return didUpdate.isSome ? didUpdate.unwrap().some(function (paraId) {
    return paraId.eq(id);
  }) : false;
}